export const removeHTMLTags = (str) => {
	return str.replace(/<\/?[^>]+(>|$)/g, '');
};

export const removeHTMLTagsAndEntities = (str) => {
	const cleanedStr = removeHTMLTags(str); // Remove HTML tags
	const div = document.createElement('div'); // Create a new div element

	div.innerHTML = cleanedStr; // Set the innerHTML of the div to the cleaned string
	return div.textContent || div.innerText || '';
};

/**
 * Strips HTML tags from a string while preserving spacing. But it does not preserve bulleted lists.
 * @param {string} input
 * @returns {string} The input string with HTML tags removed and spacing preserved.
 */
export const stripHtmlTagsWithSpacing = (input = '') => {
	return input
		.replace(/<\/(p|li|ul|ol)>/gi, '\n') // replace closing tags with line breaks
		.replace(/<\/?[^>]+(>|$)/g, '') // strip remaining tags
		.replace(/\n\s*\n/g, '\n') // remove duplicate newlines
		.trim();
};

/**
 *
 * @param {string} str string to strip HTML tags from
 * @param {string[]} tagsToRemove html tags to remove
 * @returns
 */
export const stripSpecificTags = (str = '', tagsToRemove) => {
	const tagPattern = new RegExp(`</?(${tagsToRemove.join('|')})\\b[^>]*>`, 'gi');
	return str.replace(tagPattern, '');
};
